import React  from "react";
import { Tabs } from 'antd';
import Card from "components/card";
import Button from "components/button";
import PayrunDtrTable from "./components/PayrunDtrTable";
import PayrunOtTable from "./components/PayrunOtTable";
import PayrunNdTable from "./components/PayrunNdTable";
import PayrunEmployee from "./components/PayrunEmployee";
import { connect } from "react-redux";
import { useParams } from 'react-router-dom';

const EditPayrunDtr = ({recordData }) => {
	
	const { payrunId } = useParams();
	
    const items = [
	  	{
	    	key: '1',
		    label: 'DTR',
		    children: <PayrunDtrTable payrunId={payrunId} mode="edit"/>,
	  	},
	  	{
		    key: '2',
		    label: 'Overtime',
		    children: <PayrunOtTable payrunId={payrunId} mode="edit"/>,
	  	},
	  	{
		    key: '3',
		    label: 'Night Differential',
		    children: <PayrunNdTable payrunId={payrunId} mode="edit"/>,
	  	},
	];

	return (
	    <div>
	    	<div className="mt-5 grid h-full grid-cols-1 gap-4">
	    		<PayrunEmployee recordId={payrunId}/>
	    		
	    		<Card extra={"w-full h-full p-4"}>
	      			<Tabs defaultActiveKey="1" items={items}/>
	      		</Card>
				<div className="flex flex-row-reverse text-right">
					<a className="btn btn-primary me-3" href={`/console/payrolls/${recordData?.payroll?.pay_id}/payruns/${payrunId}/view`}>
						Back
					</a>						
				</div>
	      </div>
	    </div>
    );
};

const mapStateToProps = (state) => ({
  	recordData: state.payrun.payrunDetails?.data,
});

const mapDispatchToProps = (dispatch) => ({
	
});

export default connect(mapStateToProps, mapDispatchToProps)(EditPayrunDtr);